(() => {
  const fetchRecommendations = async (root, intent) => {
    const url = new URL(root.dataset.clRelatedUrl, window.location.origin);
    url.searchParams.set('section_id', root.dataset.clRelatedSectionId);
    url.searchParams.set('product_id', root.dataset.clRelatedProductId);
    url.searchParams.set('limit', root.dataset.clRelatedLimit);
    url.searchParams.set('intent', intent);

    const response = await fetch(url, {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin',
    });

    if (!response.ok) return false;

    const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
    const replacement = documentFragment.querySelector('[data-cl-related-grid]');
    const count = Number.parseInt(replacement?.dataset.clRelatedCount || '0', 10);

    if (!replacement || count < 1) return false;

    const grid = root.querySelector('[data-cl-related-grid]');
    if (!grid) return false;

    grid.replaceChildren(...Array.from(replacement.childNodes));
    grid.dataset.clRelatedCount = String(count);
    grid.dataset.clRelatedSource = intent;
    return true;
  };

  const initialize = (root) => {
    if (root.dataset.clRelatedReady === 'true') return;
    root.dataset.clRelatedReady = 'true';

    if (!root.dataset.clRelatedProductId || !root.dataset.clRelatedUrl) return;

    fetchRecommendations(root, 'complementary')
      .then((found) => (found ? true : fetchRecommendations(root, 'related')))
      .catch(() => {});
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-cl-related]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
